import './footer.css';

const Footer = () => {
    return (
        <footer className="App-footer">
            <a href="https://doubleedge.gg" target="_blank">Double Edge Games</a>
            <span className="separator">|</span>
        <a href="https://doubleedge.gg/privacy" target="_blank">Privacy Policy</a>
            <span className="separator">|</span>
            <a href="mailto:contact@doubleedge.gg">contact@doubleedge.gg</a>
            <span className="separator">|</span>
            <span>© Double Edge Games, Inc. 2025</span>
        </footer>
    );
};

export default Footer;
